<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">

                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Asset Category"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="category_id.value.value"
                        :items="getAssetCategoryList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="category_id.errorMessage.value"
                        autocomplete="off"
                        hide-details
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                    </v-col>

                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Asset Location"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="location_id.value.value"
                        :items="getAssetLocationsList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="location_id.errorMessage.value"
                        autocomplete="off"
                        hide-details
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                    </v-col>

                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Asset Status"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="status_id.value.value"
                        :items="getAssetStatusTypesList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="status_id.errorMessage.value"
                        autocomplete="off"
                        hide-details
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Asset Register Report
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  
                  <v-col md="3" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="6" cols="12">
                    <div class="d-flex justify-center">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                  </v-col>

                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="reports"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.purchase_cost="{ item }">
                    {{ formatCurrency(item.purchase_cost) }}
                  </template>

                  <template v-slot:item.current_value="{ item }">
                    {{ formatCurrency(item.current_value) }}
                  </template>

                  <template v-slot:item.salvage_value="{ item }">
                    {{ formatCurrency(item.salvage_value) }}
                  </template>

                  <template v-slot:item.quantity="{ item }">
                    {{ Number(item.quantity).toFixed(2) }}
                  </template>

                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import Axios from "axios";
import { prefix } from "@/store/api";

export default {
  components: {},
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    search: "",
    dialog: false,
    data: {},
    headers: [
      { title: "#SL", align: "center", key: "index", sortable: false,},
       { title: "Category", key: "category_name", align: "left", sortable: false },
      { title: "Asset Name", key: "name", align: "left", sortable: false },
      { title: "Asset Code", key: "code", align: "left", sortable: false },
      { title: "Specification", key: "specification", align: "left", sortable: false },
      { title: "Model", key: "model", align: "left", sortable: false },
      { title: "Main Location", key: "branch_name", align: "left", sortable: false },
      { title: "Sub Location", key: "location_name", align: "left", sortable: false },
      { title: "Physical Location/User", key: "assignment_employee_name", align: "left", sortable: false },
      { title: "Status", key: "status_name", align: "center", sortable: false },
      { title: "Acquisition Date", key: "purchase_date", align: "center", sortable: false },
      { title: "Supplier/Donar", key: "supplier_name", align: "center", sortable: false },
      { title: "Funding Source", key: "funding_source", align: "center", sortable: false },
      { title: "Acquisition Cost", key: "purchase_cost", align: "right", sortable: false },
      { title: "Deprication Rate", key: "deprecation_rate", align: "right", sortable: false },
      { title: "Present Value", key: "present_value", align: "right", sortable: false },
      { title: "Acc. Dep Opening", key: "accumulate_depreciation_opening", align: "right", sortable: false },
      { title: "Dep. this Period", key: "accumulate_depreciation_tis_period", align: "right", sortable: false },
      { title: "Acc. Depreciation", key: "accumulated_depreciation", align: "right", sortable: false },
      { title: "Amount before impairment", key: "amount_before_impairment", align: "right", sortable: false },
      { title: "Impairment", key: "impairment", align: "right", sortable: false },
      { title: "Carrying Value", key: "carrying_value", align: "center", sortable: false },
      { title: "Remarks", key: "remarks", align: "center", sortable: false },
    ],
  }),
  watch: {},
  created() {
    const promises = [];

    // if (this.$store.getters.getAssetCategoryList.length == 0) {
      promises.push(this.$store.dispatch("getAssetCategoryList"));
    // }
    // if (this.$store.getters.getAssetLocationsList.length == 0) {
      promises.push(this.$store.dispatch("getAssetLocationsList"));
    // }
    // if (this.$store.getters.getAssetStatusTypesList.length == 0) {
      promises.push(this.$store.dispatch("getAssetStatusTypesList"));
    // }
  },
  computed: {
    getAssetCategoryList() {
      let data = this.$store.getters.getAssetCategoryList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },
    getAssetLocationsList() {
      let data = this.$store.getters.getAssetLocationsList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },
    getAssetStatusTypesList() {
      let data = this.$store.getters.getAssetStatusTypesList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        // Add validation if needed
      }),
    });

    const category_id = useField("category_id");
    const location_id = useField("location_id");
    const status_id = useField("status_id");
    const errorMessages = ref("");
    const loading = ref(false);
    const store = useStore();
    const reports = ref([]);

    const submit = handleSubmit((values) => {
      loading.value = true;

      Axios.get(`${prefix}assets/reports/asset-register`, { params: values })
        .then((response) => {
          if (response.data.success) {
            reports.value = response.data.data;
            toast.success(response.data.message || 'Data loaded successfully');
          } else {
            toast.error(response.data.message || 'Failed to load data');
          }
          loading.value = false;
        })
        .catch((error) => {
          loading.value = false;
          toast.error(error.response?.data?.message || 'An error occurred');
        });
    });

    const formatCurrency = (val) => Number(val || 0).toLocaleString('en-BD', { minimumFractionDigits: 2 });

    return {
      category_id,
      location_id,
      status_id,
      submit,
      errorMessages,
      loading,
      reports,
      formatCurrency,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },

    exportToPDF() {
      let serialNumber = 1;
      const columns = [
        "#SL",
        "Asset Code",
        "Asset Name",
        "Category",
        "Location",
        "Status",
        "Purchase Date",
        "Quantity",
        "Purchase Cost",
        "Current Value",
        "Salvage Value",
        "Useful Life",
      ];
      const rows = (this.reports || []).map((item) => [
        serialNumber++,
        item.code,
        item.name,
        item.category_name,
        item.location_name,
        item.status_name,
        item.purchase_date,
        Number(item.quantity).toFixed(2),
        this.formatCurrency(item.purchase_cost),
        this.formatCurrency(item.current_value),
        this.formatCurrency(item.salvage_value),
        item.useful_life,
      ]);
      this.$exportTableToPDF(
        columns,
        rows,
        "Asset Register Report",
        "asset_register_report_" + this.$fileDate()
      );
    },
    exportToExcel() {
      var data = [[
        "#SL",
        "Asset Code",
        "Asset Name",
        "Category",
        "Location",
        "Status",
        "Purchase Date",
        "Quantity",
        "Purchase Cost",
        "Current Value",
        "Salvage Value",
        "Useful Life",
      ]];
      var serialNumber = 1;
      (this.reports || []).forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.name,
          item.category_name,
          item.location_name,
          item.status_name,
          item.purchase_date,
          Number(item.quantity).toFixed(2),
          item.purchase_cost,
          item.current_value,
          item.salvage_value,
          item.useful_life,
        ]);
      });
      this.$exportTableToExcel(data, "asset_register_report_" + this.$fileDate());
    },
    exportToCSV() {
      var data = [[
        "#SL",
        "Asset Code",
        "Asset Name",
        "Category",
        "Location",
        "Status",
        "Purchase Date",
        "Quantity",
        "Purchase Cost",
        "Current Value",
        "Salvage Value",
        "Useful Life",
      ]];
      var serialNumber = 1;
      (this.reports || []).forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.name,
          item.category_name,
          item.location_name,
          item.status_name,
          item.purchase_date,
          Number(item.quantity).toFixed(2),
          item.purchase_cost,
          item.current_value,
          item.salvage_value,
          item.useful_life,
        ]);
      });

      this.$exportTableToCSV(data, "asset_register_report_" + this.$fileDate());
    },
  },
  mounted() {
    // Auto-trigger search on mount
    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });   
  },
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>

